//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

const productTitle = 'This link will take you to to the product detail page';

const template = `<styled-link-icon link-title="'${productTitle}'"></styled-link-icon>`;

import 'app/styled-link-icon/styled-link-icon';

angular.module('curalate').component('productLinkIcon', {
  template,
});
